<template>
  <v-container fluid>
    <v-row
      v-for="(ferramentas, categoria) in ferramentasAgrupadas"
      :id="`categoria-${categoria}`"
      :key="categoria"
      class="mx-auto"
    >
      <template v-if="!categoriaIsPrivada(categoria) || userIsAdmin">
        <h2 v-if="ferramentas.length" class="my-4 w-100">
          <span v-if="!categoriaIsPrivada(categoria)">
            {{ categoria }}
          </span>
          <v-tooltip v-else right>
            <template v-slot:activator="{ on, attrs }">
              <span v-bind="attrs" class="cat-privada-text" v-on="on">
                {{ categoria }}
              </span>
            </template>
            <span>Essa categoria foi marcada como privada, ou seja, só é exibida para administradores</span>
          </v-tooltip>
        </h2>
        <v-row class="align-stretch d-flex">
          <v-col v-for="ferramenta in ferramentas" :key="ferramenta.id" xs="12" sm="6" md="4" lg="3" xl="2">
            <v-hover v-slot:default="{ hover }">
              <a
                :href="
                  setLink(ferramenta.link_rota_principal_completo, ferramenta.ferramenta_exclusiva_hexa_v1, ferramenta.status)
                "
                style="text-decoration: none"
              >
                <v-card
                  :id="ferramenta.id"
                  :class="!ferramenta.status ? 'disabled-card' : ''"
                  :style="hover && !ferramenta.status ? 'cursor: not-allowed' : ''"
                  class="d-flex mx-auto my-auto px-2"
                  width="352px"
                  height="100%"
                  :color="hover && ferramenta.status ? 'grey lighten-2' : 'grey lighten-3'"
                  elevation="1"
                  :to="
                    !ferramenta.ferramenta_exclusiva_hexa_v1 && ferramenta.status ? ferramenta.link_rota_principal_completo : ''
                  "
                  @click="!ferramenta.status && $event.preventDefault()"
                >
                  <hint v-if="!ferramenta.status" msg-modal="" :add-hexa-final-string="true">
                    <template slot="text">
                      Esta ferramenta não está habilitada para seu usuário, caso tenha interesse, entre em contato com um
                      especialista
                      <b>NORVEN</b>
                      pelo chat.
                    </template>
                  </hint>
                  <v-row no-gutters align="center" justify="center">
                    <v-col cols="2">
                      <v-icon class="d-flex justify-center my-auto" :size="40" color="#E5502C">{{ ferramenta.icone }}</v-icon>
                    </v-col>
                    <v-col cols="10">
                      <v-card-text class="mx-auto my-auto">
                        <div class="subtitle-2" style="word-break: normal">
                          {{ ferramenta.nome }}
                        </div>
                        <div class="caption text--secondary">
                          {{ ferramenta.descricao }}
                        </div>
                      </v-card-text>
                    </v-col>
                  </v-row>
                </v-card>
              </a>
            </v-hover>
          </v-col>
        </v-row>
      </template>
    </v-row>
  </v-container>
</template>

<script>
  import tourMixins from '@/mixins/tourMixins';

  export default {
    components: {
      Hint: () => import('@/components/general/Hint')
    },

    mixins: [tourMixins],

    data() {
      return {
        categoriasFerramentas: {},
        refEmpresa: '',
        dados: {},
        arrTour: [
          {
            title: 'Power Ups',
            intro: 'Aqui você encontrará de forma organizada todas as ferramentas disponíveis no <b>HEXA</b>.'
          },
          {
            element: '#categoria-1',
            intro: 'Nesta seção estão disponíveis as Ferramentas de <b>Gestão de BRR</b>.',
            position: 'bottom',
            scrollTo: 'tooltip'
          },
          {
            element: '#categoria-2',
            intro: 'Nesta seção estão disponíveis os <b>Algoritmos de Fiscalização da ANEEL</b>.',
            position: 'bottom',
            scrollTo: 'tooltip'
          },
          {
            element: '#categoria-3',
            intro: 'Nesta seção estão disponíveis as Ferramentas de <b>BPR, COGE e Atributos MCPSE</b>.',
            position: 'bottom',
            scrollTo: 'tooltip'
          },
          {
            element: '#categoria-4',
            intro: 'Nesta seção estão disponíveis as Ferramentas de <b>Conformidade</b>.',
            position: 'bottom',
            scrollTo: 'tooltip'
          },
          {
            element: '#categoria-5',
            intro: 'Nesta seção estão disponíveis as Ferramentas de <b>Contabilidade Regulatória</b>.',
            position: 'top',
            scrollTo: 'tooltip'
          },
          {
            element: '#categoria-6',
            intro: 'Nesta seção estão disponíveis as Ferramentas de <b>Gestão de BDGD</b>.',
            position: 'top',
            scrollTo: 'tooltip'
          },
          {
            element: '#categoria-7',
            intro: 'Nesta seção estão disponíveis as Ferramentas de <b>Arquivos</b>.',
            position: 'top',
            scrollTo: 'tooltip'
          }
        ]
      };
    },

    computed: {
      categorias() {
        return this.$store.state.app.modulosPerfisLiberados.categorias;
      },
      ferramentasLiberadas() {
        return this.$store.state.app.modulosPerfisLiberados.ferramentas_liberadas;
      },
      ferramentasAgrupadas() {
        /* Sintaxe json implemntada para duplicar o valor de ferramentasAgrupadas sem interferir no state do vuex */
        let ferramentasAgrupadas = JSON.parse(JSON.stringify(this.$store.state.app.modulosPerfisLiberados.ferramentas));

        for (const categoria in ferramentasAgrupadas) {
          ferramentasAgrupadas[categoria] = ferramentasAgrupadas[categoria].filter((ferramenta) => {
            if (ferramenta.tipo !== 'POWER_UP') return false;

            let ferramentaLiberada = false;
            if (ferramenta.status) {
              ferramentaLiberada = this.ferramentasLiberadas.some((ferramentaLiberada) => ferramentaLiberada.id == ferramenta.id);
            }

            ferramenta.status = ferramentaLiberada;
            return true;
          });
        }
        return ferramentasAgrupadas;
      },
      userIsAdmin() {
        return this.$store.getters.userIsAdmin;
      }
    },

    mounted() {
      this.iniciarTourPagina();
    },

    methods: {
      setLink(link, ferramenta_exclusiva_hexa_v1, status) {
        if (ferramenta_exclusiva_hexa_v1 && status) {
          return `https://${this.$store.getters.getEmpresa}.gestaohexa.com.br/${link}`;
        } else {
          return '';
        }
      },

      categoriaIsPrivada(categoriaNome) {
        let categoria = this.categorias.find((categoria) => categoria.nome == categoriaNome);

        return categoria.categoria_privada ? true : false;
      },

      iniciarTourPagina() {
        if (this.tourFuncCalled) return;
        this.iniciarTour(this.arrTour);
      }
    }
  };
</script>

<style>
  .disabled-card {
    opacity: 0.5;
    border-color: transparent !important;
  }
</style>
